import { VehicleValuationStatus } from "@/api-schema-enums";
import { BadgeColorVariant, BadgeVariant } from "@/components/ui/badge";

type BadgeVariantTuple = { variant: BadgeVariant; colorVariant: BadgeColorVariant };

export const getVehicleValuationStatusBadgeVariant = (status: VehicleValuationStatus): BadgeVariantTuple => {
  switch (status) {
    case VehicleValuationStatus.Failed:
    case VehicleValuationStatus.OverhaulNeeded:
      return { variant: BadgeVariant.Outlined, colorVariant: BadgeColorVariant.Error };
    case VehicleValuationStatus.WaitingForConfirmation:
      return { variant: BadgeVariant.Outlined, colorVariant: BadgeColorVariant.Secondary };
    case VehicleValuationStatus.VehicleSelectionRequired:
    case VehicleValuationStatus.InProgress:
      return { variant: BadgeVariant.Outlined, colorVariant: BadgeColorVariant.Warning };
    case VehicleValuationStatus.Confirmed:
      return { variant: BadgeVariant.Outlined, colorVariant: BadgeColorVariant.Success };
  }
};
